// Exports
module.exports = {
	"forklaringsscroll": "dh-forklaringsscroll-forklaringsscroll",
	"rootJs": "dh-forklaringsscroll-root--js",
	"cardContainer": "dh-forklaringsscroll-cardContainer",
	"card": "dh-forklaringsscroll-card",
	"forklaringsscrollLeft": "dh-forklaringsscroll-forklaringsscroll--left",
	"forklaringsscrollRight": "dh-forklaringsscroll-forklaringsscroll--right",
	"cardContainerFirst": "dh-forklaringsscroll-cardContainer--first",
	"cardContainerLast": "dh-forklaringsscroll-cardContainer--last"
};
